import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import contactActions from 'actions/contacts/actions';
import ContactActionForm from './contact-action-form'


const ContactAction = ({ setAction, venueId, setSelectedSection, handleSetSuccess, action, contact, createOrEditContact }) => {
  const title = action === 'add' ? 'Add Contact' : 'Edit Contact'
  return (
    <div className="add-contact">
      <div className="flex items-center text-primary-orange cursor-pointer w-max" onClick={() => setAction('view')}>
        <i className="fa fa-caret-left mr-3" aria-hidden="true"></i>
        <p className="text-xs">Back to All Venue Contacts</p>
      </div>
      <div className="header py-3">
        <h1 className="font-bold py-1 text-3xl">{title}</h1>
        <p className="py-1 text-gray-600">Input the information of the Contact/s who will be managing the spaces in this venue.
          Please make sure to have at least 1 contact per venue. The contact/s added will be notified for all new leads and customer messages.
        </p>
      </div>
      {action === 'add' && <ContactActionForm onSubmit={createOrEditContact} form="merchant-add-contact" action={action} initialValues={{ venue_id: venueId, action }} handleSetSuccess= {handleSetSuccess} setSelectedSection= {setSelectedSection} venueId={venueId} />}
      {action === 'edit' && <ContactActionForm onSubmit={createOrEditContact} form="merchant-edit-contact" action={action} initialValues={{ ...contact, action }} handleSetSuccess= {handleSetSuccess} setSelectedSection= {setSelectedSection} venueId={venueId} />}
    </div>
  )
}

ContactAction.propTypes = {
  setAction: PropTypes.func,
  venueId: PropTypes.number,
  setSelectedSection: PropTypes.func,
  handleSetSuccess: PropTypes.func,
  action: PropTypes.string,
  contact: PropTypes.object,
  createOrEditContact: PropTypes.func
}

const mapDispatchToProps = {
  createOrEditContact: contactActions.createOrEditContact,
}

export default connect(null, mapDispatchToProps)(ContactAction)
